import { Link } from "react-router-dom";
import { Users, Building2, Home as HomeIcon, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useNoIndex } from "@/portal/PortalAuth";

const CARDS = [
  { to: "/guest", label: "Guest Portal", icon: Users, copy: "For current Masaya Hospitality guests. View your stay, payments, house info, and submit requests.", testid: "portal-guest" },
  { to: "/management", label: "Management Portal", icon: Building2, copy: "For Masaya Hospitality Admin, Managers, Reservations, Housekeeping, and Maintenance staff.", testid: "portal-management" },
  { to: "/homeowner", label: "Homeowner Portal", icon: HomeIcon, copy: "For property owners working with Masaya Hospitality. View your assigned properties and activity.", testid: "portal-homeowner" },
];

export default function PortalHub() {
  useNoIndex();
  return (
    <section data-testid="portal-hub" className="px-6 md:px-12 pt-36 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-5xl mx-auto">
        <Reveal className="max-w-2xl">
          <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">Portal Login</span>
          <h1 className="mt-5 text-5xl sm:text-6xl tracking-tighter font-light leading-none text-[#1C1917]">Select your portal</h1>
          <p className="mt-8 text-lg text-[#44403C] leading-relaxed font-light">Choose the portal that matches your account. Access is invite-only.</p>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {CARDS.map((c) => (
            <Reveal key={c.to}>
              <Link to={c.to} data-testid={c.testid} className="group h-full flex flex-col justify-between rounded-2xl border border-[#E7E5E4] bg-white p-8 hover:border-[#8A9A86] hover:-translate-y-1 transition-all duration-300">
                <div>
                  <span className="w-12 h-12 rounded-full bg-[#E8ECE7] flex items-center justify-center mb-6">
                    <c.icon className="w-5 h-5 text-[#748570]" strokeWidth={1.5} />
                  </span>
                  <h2 className="text-2xl font-normal tracking-tight text-[#1C1917]">{c.label}</h2>
                  <p className="mt-3 text-[#44403C] font-light leading-relaxed">{c.copy}</p>
                </div>
                <span className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-[#1C1917] group-hover:text-[#8A9A86] transition-colors duration-300">
                  {c.label} <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
